module.exports = __webpack_public_path__ + "fonts/Roboto-500-symbols45.8feefe1.woff2";